<template>
     <el-card class="page_card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <span>终端配置</span>
        </div>
        <el-form inline :model="selectForm" ref="selectForm">
            <el-form-item label="配置信息" >
                <el-input v-model="selectForm.keyword"  show-word-limit placeholder="请填输入关键字"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button plain type="primary" @click="querySubmit()">查 询</el-button>
                <el-button plain @click="reset()">重 置</el-button>
            </el-form-item>
            <el-form-item label="">
                <el-button type="success"  v-can="['btn:configuration_modification']" plain @click="add_terminal()"> + 新增终端配置</el-button>
            </el-form-item>
            <el-form-item label="">
                <el-button type="success" v-can="['btn:add_direction_loadometer']" plain @click="terminal_direction()"> + 设置地磅方向</el-button>
            </el-form-item>
            <el-form-item label="">
                <el-button type="success" v-can="['btn:terminal_log']" plain @click="terminal_logs()">终端操作日志</el-button>
            </el-form-item>
        </el-form>

        <!-- list列表 -->
          <el-row>
            <el-col :span="24">
                <el-table empty-text="暂无数据"
                          ref="table"
                          row-key="id"
                          :loading="is_post"
                          :data="DataList"
                          tooltip-effect="dark"
                          style="width: 100%"
                          >
                    <el-table-column label="序号" type="index">
                    </el-table-column>
                    <el-table-column label="名称">
                        <template slot-scope="scope">
                            <span class="primary_text">{{scope.row.name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="配置键">
                        <template slot-scope="scope">
                            <span class="success_text">{{scope.row.key}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="配置值">
                        <template slot-scope="scope">
                            <span class="warning_text">{{scope.row.value}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人">
                        <template slot-scope="scope">
                            {{scope.row.createUserName}}
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            {{scope.row.createTime}}
                        </template>
                    </el-table-column>
                     <el-table-column label="更新人">
                        <template slot-scope="scope">
                            {{scope.row.updateUserName}}
                        </template>
                    </el-table-column>
                     <el-table-column label="更新时间">
                        <template slot-scope="scope">
                            {{scope.row.updateTime}}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span class="success_text" v-if='scope.row.status=="0"'>启用</span>
                            <span class="danger_text" v-if='scope.row.status=="1"'>禁用</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="250">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="warning"
                                    plain
                                    @click="editBtn(scope.row)"
                            >
                                <svg-icon icon-class="change" />
                            </el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    plain
                                    :loading="is_post"
                                    @click="del(scope.row)"
                            >
                                <svg-icon icon-class="del" />
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <footer style="height: 50px;bottom: 10px;width: calc(100% - 40px);">
                <el-pagination
                    style="float: left;position: relative;top: 10px;"
                    @current-change="pageChange"
                    :current-page.sync="selectForm.pageNum"
                    :page-size="selectForm.pageSize"
                    :hide-on-single-page="false"
                    layout="prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
             </footer>
        </el-row>

        <!-- 新增 -->
         <el-dialog
            title="添加配置"
            :visible.sync="add_dialog"
            width="30%"
        >
            <el-form ref="addForm" :rules="addRules" :model="addForm" label-width="100px">
                <el-form-item label="配置名称:" prop="name">
                    <el-input v-model="addForm.name" placeholder="请输入配置名称" :maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="配置键:" prop="key">
                    <el-input v-model="addForm.key" placeholder="请输入配置键" :maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="配置值:" prop="value">
                    <el-input v-model="addForm.value" placeholder="请输入配置值" :maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="是否启用:">
                    <el-switch
                        style="position: relative;top: 4px;display: block"
                        v-model="addForm.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="启用"
                        inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain @click="addSubmit()" >提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 新增地磅方向 -->
         <el-dialog
            title="地磅方向设置"
            :visible.sync="direction_dialog"
            width="30%"
        >
            <el-form ref="selectFormDir" :rules="dirRules" :model="selectFormDir" label-width="100px">
                <el-form-item label="地磅1:" prop="type1">
                    <el-select v-model="selectFormDir.type1" placeholder="请选择"  style="width: 85%;">
                        <el-option label="双向通行" value="1"></el-option>
                        <el-option label="禁止通行" value="2"></el-option>
                        <el-option label="前到后通行" value="3"></el-option>
                        <el-option label="后到前通行" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="地磅2:" prop="type2">
                    <el-select v-model="selectFormDir.type2" placeholder="请选择" style="width: 85%;">
                        <el-option label="双向通行" value="1"></el-option>
                        <el-option label="禁止通行" value="2"></el-option>
                        <el-option label="前到后通行" value="3"></el-option>
                        <el-option label="后到前通行" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" style="display: flex;justify-content: center; margin-right: 100px;">
                    <el-button type="primary" plain @click="addDirSubmit()" >提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 终端操作日志 -->
        <el-dialog
            title="终端操作日志"
            :visible.sync="terminal_logs_dialog"
            width="50%"
        >
            <el-form inline :model="selectFormLogs" ref="selectFormLogs">
                <el-form-item label="操作时间">
                    <el-date-picker
                        v-model="selectFormLogs.timeRange"
                        type="daterange"
                        align="right"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="">
                    <el-button plain type="primary" @click="querySubmitLogs()">查 询</el-button>
                    <el-button plain @click="resetLogs()">重 置</el-button>
                </el-form-item>
            </el-form>
            <!-- 终端操作日志列表 -->
            <el-row>
                <el-col :span="24">
                    <el-table empty-text="暂无数据"
                            ref="table"
                            row-key="id"
                            :loading="is_post"
                            :data="DataLogsList"
                            tooltip-effect="dark"
                            style="width: 100%"
                            >
                        <el-table-column label="序号" type="index">
                        </el-table-column>
                        <el-table-column label="名称">
                            <template slot-scope="scope">
                                <span class="primary_text">{{scope.row.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作内容">
                            <template slot-scope="scope">
                                <span class="success_text">{{scope.row.operContent}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作项">
                            <template slot-scope="scope">
                                <span class="warning_text">{{scope.row.operItem}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作时间">
                            <template slot-scope="scope">
                                {{scope.row.operTime}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作人">
                            <template slot-scope="scope">
                                {{scope.row.operUserName}}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
                <footer style="height: 50px;bottom: 10px;width: calc(100% - 40px);">
                    <el-pagination
                        style="float: left;position: relative;top: 10px;"
                        @current-change="pageChangeLog"
                        :current-page.sync="selectFormLogs.pageNum"
                        :page-size="selectFormLogs.pageSize"
                        :hide-on-single-page="false"
                        layout="prev, pager, next, jumper"
                        :total="totalLog">
                    </el-pagination>
                </footer>
            </el-row>
        </el-dialog>
        <!-- 编辑 -->
         <el-dialog
            title="修改配置"
            :visible.sync="edit_dialog"
            width="30%"
        >
            <el-form ref="editForm" :rules="addRules" :model="editForm" label-width="100px">
                <el-form-item label="配置名称:" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入配置名称" :maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="配置键:" prop="key">
                    <el-input v-model="editForm.key" placeholder="请输入配置键" :maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="配置值:" prop="value">
                    <el-input v-model="editForm.value" placeholder="请输入配置值" :maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="是否启用:">
                    <el-switch
                        style="position: relative;top: 4px;display: block"
                        v-model="editForm.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="启用"
                        inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain @click="editSubmit()" >提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
     </el-card>
</template>

<script>
import request from "@/utils/request"
import can from "@/directive/can/index.js"
import {stringTrim} from "@/utils/elvalid"
export default{
    directives:{can},
    data(){
        return{
            is_ok:true,
            is_loading:false,
            add_dialog:false,
            direction_dialog:false,
            terminal_logs_dialog:false,
            edit_dialog:false,
            is_post:true,
            DataList:[],
            DataLogsList:[],
            total:'',
            totalLog:'',
            selectFormDir:{
                direction:[],
            },
            selectForm:{
                keyword:'',
                pageNum:1,
                pageSize:10,
            },
            selectFormLogs:{
                timeRange:[],
                pageNum:1,
                pageSize:10,
            },
            addForm:{
                name:'',
                key:'',
                value:'',
                status:true,
            },
            editForm:{
                name:'',
                key:'',
                value:'',
                status:true,
            },
            addRules:{
                name:[
                    { required: true, message: '请输入配置名称', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' },
                ],
                value:[
                    { required: true, message: '请输入配置值', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' },
                    { pattern:/^[0-9a-z]{1,20}$/, message: '只支持小写字母或数字', trigger: 'blur' }
                ],
                key:[
                    { required: true, message: '请输入配置键', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' },
                    { pattern:/^.{1,20}$/, message: '最多输入20个字符', trigger: 'blur' }
                ]
            },
            dirRules:{
                type1:[
                    { required: true, message: '请选择地磅1方向', trigger: 'blur' },
                ],
                type2:[
                    { required: true, message: '请选择地磅2方向', trigger: 'blur' },
                ]
            },
        }
    },
    mounted(){
        this.getData()
    },

    methods:{
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        pageChangeLog(page){
            this.selectFormLogs.pageNum = page;
            this.getLogData();
        },
         // 初始化数据
        getData(){
            request.post('/csconfig/page',this.selectForm).then(res=>{
                if(res.code=='200'){
                   if(res.data.list.length>0){
                      this.is_post=false
                      this.DataList=res.data.list
                      this.total=res.data.total
                   }else{
                       this.is_post=true
                       this.DataList=res.data.list
                   }
                }
            })
        },
        // 获取终端操作日志
        getLogData(){
            request.post('/log/oper_log_list',this.selectFormLogs).then(res=>{
                if(res.code=='200'){
                   if(res.data.list.length>0){
                      this.is_post=false;
                      this.DataLogsList=res.data.list;
                      this.totalLog=res.data.total;
                   }else{
                       this.is_post=true
                       this.DataLogsList=res.data.list
                   }
                }
            })
        },
        //查询
        querySubmit(){
            this.getData();
        },
        //重置
        reset(){
            this.selectForm.keyword=''
            this.getData()
        },
        //新增终端菜单
        add_terminal(){
            this.add_dialog=true
        },
        //新增提交
        addSubmit(){
             this.$refs['addForm'].validate(value=>{
                if(!value)return false;
                request.post('/csconfig/add',this.addForm).then(res=>{
                    if(res.code=='200'){
                         this.$refs["addForm"].resetFields();
                        this.add_dialog=false;
                        this.getData();
                        this.$message.success('添加成功')
                    }else{
                        this.$message.error('添加失败')
                    }
                })
           })
        },
        //新增地磅方向
        terminal_direction(){
            this.direction_dialog=true
        },
        //新增地磅方向提交
        addDirSubmit(){
             this.$refs['selectFormDir'].validate(value=>{
                if(!value)return false;
                this.selectFormDir.direction = [this.selectFormDir.type1,this.selectFormDir.type2]
                request.post('cs_set_direction',this.selectFormDir).then(res=>{
                    if(res.code=='200'){
                         this.$refs["selectFormDir"].resetFields();
                        this.direction_dialog=false;
                        this.getData();
                        this.$message.success('地磅方向设置成功')
                    }else{
                        this.$message.error('地磅方向设置失败')
                    }
                })
           })
        },
        //终端操作日志
        terminal_logs(){
            this.terminal_logs_dialog=true;
            this.getLogData();
        },
        //查询日志
        querySubmitLogs(){
            this.getLogData();
        },
        //重置日志
        resetLogs(){
            this.selectFormLogs.timeRange=[];
            this.getLogData();
        },
        //删除
        del(item){
            this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                request.post('/csconfig/delete',{id:item.id}).then(res=>{
                    if(res.code=='200'){
                        this.$message.success('删除成功')
                        this.getData()
                    }else{
                        this.$message.error('删除失败')
                    }
               })
            }).catch(() => {

            });

        },
        //编辑
        editBtn(item){
           this.edit_dialog=true;
           this.editForm.id=item.id;
           this.editForm.name=item.name;
           this.editForm.key=item.key;
           this.editForm.value=item.value;
           if(item.status==0){
              this.editForm.status=true
           }else{
               this.editForm.status=false
           }
        },
        //编辑提交按钮
        editSubmit(){
            this.$refs['editForm'].validate(value=>{
                if(!value)return false;
                request.post('/csconfig/edit',this.editForm).then(res=>{
                    if(res.code=='200'){
                        this.edit_dialog=false;
                        this.getData()
                        this.$message.success('修改成功')
                    }else{
                        this.$message.error('修改失败')
                    }
                })
            })
        }
    }
}
</script>

